module.exports = __webpack_public_path__ + "static/img/app-presentation-step-4.fec2ccd.png";